﻿import * as Repositories from '../../repositories/repositories'
import * as Model from '../../models/models';
import {EventLogViewModel} from './eventLog.viewmodel';
import * as _ from 'lodash';
import EventLogModel = require("../../models/eventLog.model");
import IEventLog = EventLogModel.IEventLog;

export class EventLogGateway {

    static $inject = ['$q', '$log', 'eventLogRepository'];

    constructor(private $q: ng.IQService,
        private $log: ng.ILogService,
        private eventLogRepository: Repositories.EventLogRepository
    ) { }

    public eventLogViewModel: EventLogViewModel;

    public loadViewModel(): ng.IPromise<EventLogViewModel> {
        this.eventLogViewModel = new EventLogViewModel();
        return this.$q.all([
                this.getEventLogApplications(),
                this.getEventLogLoggers(),
                this.getEventLogSeverities()
            ])
            .then(() => this.$q.when(this.eventLogViewModel));
    }

    private getEventLogApplications = (): ng.IPromise<string[]> => {
        return this.eventLogRepository.getEventLogApplications()
            .then((applications: Array<string>) => this.eventLogViewModel.applicationOptions = applications);
    }

    private getEventLogLoggers = (): ng.IPromise<string[]> => {
        return this.eventLogRepository.getEventLogLoggers()
            .then((loggers: Array<string>) => this.eventLogViewModel.loggerOptions = loggers);
    }

    private getEventLogSeverities = (): ng.IPromise<string[]> => {
        return this.eventLogRepository.getEventLogSeverities()
            .then((severities: Array<string>) => this.eventLogViewModel.severityOptions = severities);
    }


    public getEventLogs = (searchCriteriaModel: Model.IEventLogSearchCriteria): ng.IPromise<EventLogViewModel> => {
        const eventLogViewModel = new EventLogViewModel();
        eventLogViewModel.searchResults = new Array<IEventLog>();
        searchCriteriaModel.eventTimeFromLocal = this.convertUtcTimeToLocalTime(searchCriteriaModel.eventTimeFromUtc);
        searchCriteriaModel.eventTimeToLocal =  this.convertUtcTimeToLocalTime(searchCriteriaModel.eventTimeToUtc);
        return this.$q.all([
            this.eventLogRepository.eventLogSearch(searchCriteriaModel)
                .then((eventLogs: Array<Model.IEventLog>) => eventLogViewModel.searchResults = eventLogs),
            this.eventLogRepository.eventLogSearchRecordCount(searchCriteriaModel)
                .then((recordCount: number) => eventLogViewModel.recordCount = recordCount)
        ]).then(() => this.$q.when(eventLogViewModel));
    }

    public getEventLog = (eventLogId: string): ng.IPromise<IEventLog> => {
        return this.eventLogRepository.getEventLog(eventLogId)
            .then((searchResult: Model.IEventLog) => {
                return searchResult;
            })
            .catch((err) => {
                console.log(err);
                return new Model.EventLog();
            });
    }

    private convertUtcTimeToLocalTime = (date: Date): Date => {
        return date != null ? new Date(date.getTime() + (60000 * date.getTimezoneOffset())) : null;
    }
}